import { useEffect, useRef } from 'react';
import { useAuthStore } from '../../store/authStore';
import { whenChatwootReady } from '../../utils/chatwoot';

export const ChatwootChat: React.FC = () => {
  const { user } = useAuthStore();
  const identifiedUserId = useRef<string | null>(null);

  useEffect(() => {
    // Logout: drop the Chatwoot session so the next user on this browser
    // doesn't inherit the previous one's conversation.
    if (!user) {
      if (identifiedUserId.current) {
        identifiedUserId.current = null;
        try {
          window.$chatwoot?.reset();
        } catch (error) {
          console.error('Chatwoot: failed to reset the session', error);
        }
      }
      return;
    }

    if (identifiedUserId.current === user.id) {
      return;
    }

    const identify = (chatwoot: ChatwootSdk) => {
      try {
        // Identifying the visitor prevents the widget from asking for an email again.
        chatwoot.setUser(user.id, {
          email: user.email,
          name: user.name || user.firstName || user.email?.split('@')[0] || '',
          ...(user.photoURL ? { avatar_url: user.photoURL } : {}),
        });
        identifiedUserId.current = user.id;
      } catch (error) {
        console.error('Chatwoot: failed to identify the user', error);
      }
    };

    return whenChatwootReady(identify);
  }, [user]);

  // This component doesn't render anything visible
  return null;
};
